import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { DetailedAccount, PagedResponseDetailedAccount } from '../models/DetailedAccount';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class DetailedAccountService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getDetailedAccounts():Observable<PagedResponseDetailedAccount>{
    const data =  this.http.get<PagedResponseDetailedAccount>(this.APIURL+'/DetailedAccount' + '?PageNumber=1&PageSize=150');
    this.messageService.add('DetailedAccount Service: fetched DetailedAccounts');
    return data;
  }

  getDetailedAccount(id: number): Observable<DetailedAccount> {
        const DetailedAccount =this.http.get<DetailedAccount>(this.APIURL+'/DetailedAccount/' + id);
    this.messageService.add(`DetailedAccount Service: fetched DetailedAccount with id=${id}`);
    return DetailedAccount;
  }

  getDetailedAccountByAcId(id: number): Observable<PagedResponseDetailedAccount> {
    const DetailedAccount = this.http.get<PagedResponseDetailedAccount>(this.APIURL + '/DetailedAccount/GetByAcId/' + id);
    this.messageService.add(`DetailedAccount Service: fetched DetailedAccount with Ac id=${id}`);
    return DetailedAccount;
  }
}